<template>
	<div class="modal product-modal">
      <div class="overlay" @click="$parent.closeProductModal"></div>
      <div class="wrapper">
        <img class="close" src="../images/close.svg" @click="$parent.closeProductModal" />
        <div class="container">
          <div class="preview">
            <img class="img" :src="$parent.imgDomain + $parent.chosenProoduct.img + '.png'"/>
          </div>
          <div class="text">
            <div class="title small">{{$parent.chosenProoduct.name}}</div>
            <div class="title small status">{{ $t(`Product available on all servers`) }}</div>
            <div class="price">
              <!-- Зачеркнутая цена со скидкой (сверху) -->
              <div v-if="getOriginalPrice($parent.chosenProoduct) && parseFloat(getOriginalPrice($parent.chosenProoduct)) > parseFloat($parent.chosenProoduct.price)" class="original-price">
                <img src="../images/coin.svg" class="currency-icon" alt="coin"/>
                <span class="title small amount">{{parseFloat(getOriginalPrice($parent.chosenProoduct)).toFixed(2)}}</span>
              </div>
              <!-- Текущая цена (снизу) -->
              <div class="price-content">
                <img src="../images/coin.svg" class="currency-icon" alt="coin"/>
                <span class="title small amount">{{$parent.chosenProoduct.price}}</span>
              </div>
            </div>
            <div @click="buyProduct" class="button">{{ $t(`GET IT`) }}</div>
          </div>
          <p class="info-text">
            *Price includes applicable taxes. Digital Item usable only on Rustcores servers.
          </p>
          <transition name="fade">
            <div class="desc error" v-if="error">{{error}}</div>
          </transition>
          <transition name="fade">
            <div class="desc success" v-if="success">{{success}}</div>
          </transition>
        </div>
      </div>
    </div>
</template>

<script>
export default {
	name: 'ProductModal',
	props: ['currency'],
	data: function() {
		return {
			error: '',
      success: ''
		}
	},
		methods: {
		getOriginalPrice(item) {
			// Проверяем разные возможные поля для оригинальной цены
			const possibleFields = [
				'original_price',
				'old_price', 
				'regular_price',
				'base_price',
				'list_price',
				'msrp',
				'retail_price',
				'full_price',
				'discount_price',
				'sale_price'
			];
			
			for (let field of possibleFields) {
				if (item[field] && parseFloat(item[field]) > parseFloat(item.price)) {
					return item[field];
				}
			}
			
			return null;
		},
		buyProduct() {
      this.$http.post(process.env.VUE_APP_API + 'orders?item_id=' + this.$parent.chosenProoduct.id)
      .then((res) => {
        let self = this;
        if (res.data.status === 'OK') {
          this.$parent.getProfileData();
          this.success = 'Thank you for purchase!';
          setTimeout(function() {
            this.success = '';
            self.$parent.closeProductModal();
          }, 1500)
        } 
        if (res.data.status === 'ERROR') {
          this.error = res.data.message;
          setTimeout(function() {
            self.error = '';
          }, 1500)
        } 
        
      })
      .catch((res) => {
        if (res?.response?.status === 401) {
          this.error = 'You are not logged in to Account';
          return;
        }
        this.error = res?.response?.data?.message || res?.message || 'Something went wrong';
      })
      
    }
	},
}
</script>
